import axios from '../app/axios';

export const carouselAPI = {
  getAll: async () => {
    const response = await axios.get('/carousels');
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`/carousels/${id}`);
    return response.data;
  },
  create: async (carousel) => {
    const response = await axios.post('/carousels', carousel);
    return response.data;
  },
  update: async (id, carousel) => {
    const response = await axios.put(`/carousels/${id}`, carousel);
    return response.data;
  },
  delete: async (id) => {
    const response = await axios.delete(`/carousels/${id}`);
    return response.data;
  },
  reorder: async (carousels) => {
    const response = await axios.post('/carousels/reorder', { carousels });
    return response.data;
  },
};
